import { base64Encode, randomUUID } from '@account-service/core'

import { AUTH_SERVER, SSO_AUTH_LOGIN_OBJ, SSO_STATE_KEY } from '~/constants'
import { getTokenIdSSO, setCodeVerifier } from '~/core/cookie'
import { generateCodeChallenge, generateRandomString } from '~/utils/helper'

export type TMFAParams = {
  scope?: string
  setup?: string
  mfa_method?: string
  redirect_uri?: string
}

export type TAuthLogin = {
  state: string
  code_challenge: string
  code_challenge_method: string
  response_type: string
  request_type: string
  ux_mode: string
  scope: string
  client_id: string
  redirect_uri: string
  remember: string
  id_token_hint?: string
  acr_values?: string
  expires_in?: string
}

export const toUrlSSOLogin = () => {
  const codeVerifier = generateRandomString()
  const codeChallenge = generateCodeChallenge(codeVerifier)
  setCodeVerifier(codeVerifier)

  // Save current url to redirect after login
  const redirectUrl = encodeURIComponent(window.location.href)

  const state = base64Encode(
    JSON.stringify({
      random: randomUUID(),
      next: decodeURIComponent(redirectUrl),
    }),
  )

  localStorage.setItem(SSO_STATE_KEY, state)

  const AUTH_OBJ: TAuthLogin = {
    ...SSO_AUTH_LOGIN_OBJ,
    state,
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
  }

  const baseAuthQueryStr = new URLSearchParams(AUTH_OBJ).toString()
  return `${AUTH_SERVER}oauth2/auth?${baseAuthQueryStr}`
}

export const toUrlMFALogin = (data: TMFAParams) => {
  const { scope = '', ...rest } = data
  const tokenId = getTokenIdSSO()

  const codeVerifier = generateRandomString()
  const codeChallenge = generateCodeChallenge(codeVerifier)
  setCodeVerifier(codeVerifier)

  const AUTH_OBJ: TAuthLogin = {
    ...SSO_AUTH_LOGIN_OBJ,
    state: randomUUID(),
    scope: `openid offline_access ${scope}`,
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
    ux_mode: 'popup',
    acr_values: 'mfa',
    expires_in: '300',
    ...rest,
  }

  if (tokenId) {
    AUTH_OBJ.id_token_hint = tokenId
  }

  const baseAuthQueryStr = new URLSearchParams(AUTH_OBJ).toString()
  return `${AUTH_SERVER}oauth2/auth?${baseAuthQueryStr}`
}
